import moment from 'moment';

export const formatVersion = (version) => {
  if (!version) return '';
  return version.toString().startsWith('v') ? version : `v${version}`;
};

export const splitTags = (tags) =>
  (tags || '').split(',').map((t) => t.trim()).filter(Boolean);

export const formatReleaseDate = (date, locale, format) => {
  if (!date) return '';
  return moment.utc(date).local().locale(locale || 'en').format(format);
};
